// @ts-nocheck: converted from JS

import Cages from '@/components/Cages/Show';

export default Cages;
